import React from 'react';
import { Card } from 'reactstrap';

import IntlMessages from '../../../../../helpers/IntlMessages';
import { AreaChart } from '../charts';
import { ThemeColors } from '../../../../../helpers/ThemeColors';
const colors = ThemeColors();

const VoucherEngineSales = ({ labels, data, currency
}) => {
    const datasets = data.map(elem => elem.sales);
    const areaChartData = {
        labels,
        datasets: [
            {
                label: 'Sales',
                data: datasets,
                borderColor: '#EF4A81',
                pointBackgroundColor: '#EF4A81',
                pointBorderColor: '#EF4A81',
                pointHoverBackgroundColor:'#EF4A81',
                pointHoverBorderColor: '#EF4A81',
                pointRadius: 4,
                pointBorderWidth: 2,
                pointHoverRadius: 5,
                fill: false,
                borderWidth: 2,
                backgroundColor: '#EF4A81',
            },
        ],
    };
    return (
        <Card className={`dashboard-filled-line-chart`}>
            <div style={{ padding: '15px' }}>
                <div className="float-left float-none-xs">
                    <div className="d-inline-block">
                        <h5 className="d-inline">
                            Sales
                        </h5>
                        <span className="text-muted text-small d-block">
                        </span>
                    </div>
                </div>
            </div>

            <div className="chart card-body pt-0">
                <AreaChart shadow data={areaChartData} />
            </div>
        </Card>
    );
};

export default VoucherEngineSales;
